import React, { Component, Fragment } from 'react';
import { connect, batch } from 'react-redux';
import { bindActionCreators } from 'redux';
import S from 'StyledAccountQueueBonus.js';
import { translation, formatMoney } from 'helpers/utilsHelper.js';
import { formatDate } from 'helpers/datesHelper.js';
import Loader from 'Loader.js';
import Pagination from 'Pagination.js';
import ModalOpacity from 'ModalOpacity.js';
import {
  fetchBonusListByFilter,
  setCurrentPage,
  fetchBonusListPending,
  fetchBonusListFulfilled,
  fetchBonusListFailure,
  manageBonus
} from 'accountBonusActions.js';
import { proccessFrontError } from 'errorActions.js';

class AccountQueueBonus extends Component {
  state = {
    selectedOfferId: null,
    showConfirmationModal: false,
    showInfoModal: false,
    modalTitle: '',
    modalDescription: '',
    infoModalTitle: '',
    infoModalDescription: '',
    status: '',
    isPendingBonusAction: false,
  };

  componentDidMount = async () => {
    const { fetchBonusListByFilter, processFrontError } = this.props;
    try {
      await fetchBonusListByFilter();
    } catch (error) {
      processFrontError(error, 'AccountQueueBonus.componentDidMount');
    }
  };

  componentWillUnmount = () => {
    const { setCurrentPage } = this.props;
    setCurrentPage(0);
  };

  goPage = (currentPage) => {
    const { fetchBonusListByFilter, setCurrentPage, processFrontError } = this.props;
    try {
      batch(() => {
        setCurrentPage(currentPage);
        fetchBonusListByFilter();
      });
    } catch (error) {
      processFrontError(error, 'AccountQueueBonus.goPage');
    }
  };

  setSelectedOfferId = (selectedOfferId) => {
    this.setState((prevState) => {
      return { ...prevState, selectedOfferId };
    });
  };

  setStatus = (status) => {
    this.setState((prevState) => {
      return { ...prevState, status };
    });
  };

  setInfoModalTextElements = (infoModalTitle, infoModalDescription) => {
    this.setState((prevState) => {
      return { ...prevState, infoModalTitle, infoModalDescription };
    });
  };

  setConfirmModalTextElements = (action) => {
    let modalTitle = '';
    let modalDescription = '';

    switch (action) {
      case 'activate':
        modalTitle = translation('account_bonus_activationTitle');
        modalDescription = translation('account_bonus_confirmActivate');
        break;
      case 'cancel':
        modalTitle = translation('account_bonus_cancellationTitle');
        modalDescription = translation('account_bonus_confirmCancel');
        break;
      case 'reject':
        modalTitle = translation('account_bonus_cancellationTitle');
        modalDescription = translation('account_bonus_confirmReject');
        break;
    }

    this.setState((prevState) => {
      return { ...prevState, modalTitle, modalDescription };
    });
  };

  toggleModal = (type) => {
    this.setState((prevState) => {
      return { ...prevState, [type]: !prevState[type] };
    });
  };

  renderBonusActionConfirmation = (offerId, status) => {
    this.setStatus(status);
    this.setConfirmModalTextElements(status);
    this.setSelectedOfferId(offerId);
    this.toggleModal('showConfirmationModal');
  };

  toggleBonusPendingStatus = () => {
    this.setState((prevState) => {
      return { ...prevState, isPendingBonusAction: !prevState['isPendingBonusAction'] };
    });
  };

  bonusActionAccept = async (offerId, status) => {
    const { manageBonus } = this.props;
    this.toggleBonusPendingStatus();

    try {
      await manageBonus(offerId, status);
      this.toggleModal('showConfirmationModal');
      this.toggleModal('showInfoModal');
      this.setInfoModalTextElements(translation('account_bonus_action_success'), '');
    } catch (error) {
      console.log(error)
      this.toggleModal('showConfirmationModal');
      this.toggleModal('showInfoModal');
      this.setInfoModalTextElements(translation('account_bonus_action_error'), translation(error));
    }
  };

  render() {
    const { isPending, bonus, limit } = this.props;
    const {
      showInfoModal,
      showConfirmationModal,
      modalTitle,
      modalDescription,
      infoModalTitle,
      infoModalDescription,
      status,
      selectedOfferId,
      isPendingBonusAction,
    } = this.state;

    const queueBonus = bonus['queue'];
    const { data, isNextPageAvailable, currentPage } = queueBonus;

    const activeBonus = bonus['active'];
    const { data: activeBonusData } = activeBonus;

    const bonusListHeaders = [
      'account_bonus_name',
      'account_bonus_amount',
      'account_bonus_totalToWager',
      'account_bonus_expiresOn',
      'account_bonus_action',
    ];

    return (
      <S.AccountQueueBonus className="account-queue-bonus">
        {isPending ? (
          <Loader />
        ) : (
          <>
            <ModalOpacity
              isOpen={showConfirmationModal}
              showHeaderIcon={false}
              showHeaderTitle={false}
              toggleOpen={this.toggleModal.bind(this, 'showConfirmationModal')}
              showHeader={false}
            >
              <S.ActivateModal>
                <S.Title>{modalTitle}</S.Title>
                <S.Description>{modalDescription}</S.Description>
                {isPendingBonusAction ? (
                  <Loader />
                ) : (
                  <S.BtnsWrapper>
                    <S.ButtonCancel
                      onClick={this.toggleModal.bind(this, 'showConfirmationModal')}
                      data-test="account_bonus_queue_cancel"
                    >
                      {translation('common_cancel')}
                    </S.ButtonCancel>
                    <S.ButtonAccept
                      onClick={this.bonusActionAccept.bind(this, selectedOfferId, status)}
                      data-test="account_bonus_queue_accept"
                    >
                      {translation('common_accept')}
                    </S.ButtonAccept>
                  </S.BtnsWrapper>
                )}
              </S.ActivateModal>
            </ModalOpacity>

            <ModalOpacity
              isOpen={showInfoModal}
              showHeaderIcon={false}
              showHeaderTitle={false}
              toggleOpen={this.toggleModal.bind(this, 'showInfoModal')}
            >
              <S.ModalInfo>
                <S.InfoTitle>{infoModalTitle}</S.InfoTitle>
                {infoModalDescription && (
                  <S.InfoDescription>{infoModalDescription}</S.InfoDescription>
                )}
              </S.ModalInfo>
            </ModalOpacity>

            <S.BonusList>
              <S.Table>
                <S.Thead>
                  <S.Tr className="queueHeader">
                    {bonusListHeaders.map((translationKey) => (
                      <S.Th key={translationKey}>{translation(translationKey)}</S.Th>
                    ))}
                  </S.Tr>
                </S.Thead>
                <S.Tbody>
                  {data?.length > 0 ? (
                    <>
                      {data.map(
                        ({ offerName, validTo, bonusValue, totalToWager, offerQueueId }) => {
                          return (
                            <Fragment key={offerQueueId}>
                              <S.Tr key={offerQueueId}>
                                <S.Td className="td">
                                  <span>{offerName}</span>
                                </S.Td>
                                <S.Td>
                                  <span className="ammount">{formatMoney(bonusValue)}</span>&nbsp;
                                  <span className="currency">{translation('common_pln')}</span>
                                </S.Td>
                                <S.Td className="amount">
                                  <span className="ammount">{formatMoney(totalToWager)}</span>&nbsp;
                                  <span className="currency">{translation('common_pln')}</span>
                                </S.Td>
                                <S.Td>
                                  <span>{formatDate(validTo, 'dd/MM/yyyy')}</span>
                                </S.Td>
                                <S.Td className="bonus-actions">
                                  <S.Button
                                    className="reject"
                                    onClick={this.renderBonusActionConfirmation.bind(
                                      this,
                                      offerQueueId,
                                      'reject'
                                    )}
                                    data-test="account_bonus_queue_delete"
                                  >
                                    {translation('account_bonus_delete')}
                                  </S.Button>
                                  <S.Button
                                    className="accept"
                                    onClick={this.renderBonusActionConfirmation.bind(
                                      this,
                                      offerQueueId,
                                      'activate'
                                    )}
                                    disabled={activeBonusData && activeBonusData.length !== 0}
                                    data-test="account_bonus_queue_use"
                                  >
                                    {translation('account_bonus_use')}
                                  </S.Button>
                                </S.Td>
                              </S.Tr>
                              <S.Tr className="spacer"></S.Tr>
                            </Fragment>
                          );
                        }
                      )}

                      <S.Tr>
                        <S.Td colSpan="6" className="pagination">
                          <Pagination
                            callback={this.goPage}
                            {...{ data, isNextPageAvailable, limit, currentPage }}
                          />
                        </S.Td>
                      </S.Tr>
                    </>
                  ) : (
                    <S.NoResult>
                      <S.Td className="noResults" colSpan="8">
                        {translation('account_bonus_notFound')}
                      </S.Td>
                    </S.NoResult>
                  )}
                </S.Tbody>
              </S.Table>
            </S.BonusList>
          </>
        )}
      </S.AccountQueueBonus>
    );
  }
}

const mapStateToProps = ({
  AccountBonus: { isPending, error, startDate, endDate, activeTab, limit, bonus },
  Auth: {
    user: { currencyCode },
  },
}) => {
  return {
    error,
    isPending,
    startDate,
    endDate,
    activeTab,
    limit,
    bonus,
    currencyCode,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    manageBonus: bindActionCreators(manageBonus, dispatch),
    fetchBonusListByFilter: bindActionCreators(fetchBonusListByFilter, dispatch),
    setCurrentPage: bindActionCreators(setCurrentPage, dispatch),
    fetchBonusListPending: bindActionCreators(fetchBonusListPending, dispatch),
    fetchBonusListFulfilled: bindActionCreators(fetchBonusListFulfilled, dispatch),
    fetchBonusListFailure: bindActionCreators(fetchBonusListFailure, dispatch),
    processFrontError: bindActionCreators(proccessFrontError, dispatch),
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountQueueBonus);
